import { EyeIcon } from '@heroicons/react/24/outline';
import { VISIBILITY } from './visibility';
import type { NoteVisibility } from '../../../services/patientNotes';

interface VisibilityPillProps {
    visibility: NoteVisibility;
    size?: 'sm' | 'xs';
}

function VisibilityPill({ visibility, size = 'sm' }: VisibilityPillProps) {
    const v = VISIBILITY[visibility];
    return (
        <span
            className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md font-inter font-semibold ${
                size === 'xs' ? 'text-[10px]' : 'text-[11px]'
            } ${v.badgeBg}`}
        >
            {visibility === 'external' ? (
                <EyeIcon className="w-2.5 h-2.5 flex-shrink-0" />
            ) : (
                <span className="w-1 h-1 rounded-full bg-current opacity-70" />
            )}
            {v.label}
        </span>
    );
}

export { VisibilityPill };
